import { useTranslation } from '../../../hooks/useTranslations';
import classes from './Spinner.module.css';

const Spinner: React.FC<any> = () => {
  const { translations } = useTranslation();
  return <div className={classes.container}>{translations('spinner')}</div>;
};

export default Spinner;
